module.exports = __webpack_public_path__ + "img/16d7c49.jpg";